import { useEffect } from 'react';

/**
 * Close-on-Escape hook for modal/drawer dialogs. Pass `open` so the
 * listener only attaches when the modal is open (avoids capturing
 * Escape from forms/games behind the modal).
 *
 * The handler calls `onClose` AND prevents default so the same Escape
 * keypress doesn't bubble up to a parent modal that's also open.
 */
export function useEscapeClose(open: boolean, onClose: () => void): void {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      e.stopPropagation();
      onClose();
    };
    document.addEventListener('keydown', handler, true);
    return () => document.removeEventListener('keydown', handler, true);
  }, [open, onClose]);
}
